import { clsx } from 'clsx';
import { FC } from 'react';
import { TableStoryblok } from 'storyblok-types';
import styles from './styles.module.css';

export const ContentTable: FC<{ blok: TableStoryblok }> = ({ blok }) => {
  if (!blok || !blok?.table) {
    return null;
  }

  const { align, textAlign, size, table } = blok;

  return (
    <table
      className={clsx(styles.table, styles[align || ''])}
      style={{ width: size, textAlign: textAlign || 'left' }}
    >
      <thead>
        <tr>
          {table.thead.map((item) => (
            <th key={item._uid}>{item.value}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {table.tbody.map((item) => (
          <tr key={item._uid}>
            {item.body.map((body) => (
              <td key={body._uid}>{body.value}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
